import { type ReactNode } from 'react'
import { type HomeScreenAnnouncement } from '@front/model'
import { TAlert, TButton } from '@components'

export const DisplayAnnouncement = ({ announcement }: { announcement: HomeScreenAnnouncement }): ReactNode => {
  if (!announcement.message) return

  return (
    <TAlert title={announcement.message}>
      {announcement.actions?.map((action) => (
        <TButton target='_blank' component='a' key={action.label} href={action.url}>
          {action.label}
        </TButton>
      ))}
    </TAlert>
  )
}
